<script>
	import { getFunctions, httpsCallable } from "firebase/functions";

	import { store } from "$lib/utilities/store";

	export let col;
	export let settingId;
	export let fld;

	let loading = false;

	$: fldObj = $store?.[col]?.docs?.[settingId]?.[fld] || {};

	$: requestData = fldObj?.value;

	const runFunction = async () => {
		if (typeof requestData !== "object") {
			console.log("requestData is not an object");
			return;
		}
		const functionName = requestData.functionName?.value;
		if (!functionName) return;

		loading = true;

		const functions = getFunctions();
		const callable = httpsCallable(functions, functionName);
		const response = await callable({ col, settingId, fld });

		console.log(response.data);
		loading = false;
	};
</script>

<div>
	<div class="my-4">
		<button
			class={`btn btn-sm btn-primary ${loading ? "loading" : ""}`}
			disabled={loading}
			on:click|preventDefault={runFunction}
		>
			Run Function
		</button>
	</div>
</div>
